import { render, staticRenderFns } from "./appenDix.vue?vue&type=template&id=2ef1c4c5&scoped=true"
import script from "./appenDix.vue?vue&type=script&lang=js"
export * from "./appenDix.vue?vue&type=script&lang=js"
import style0 from "./appenDix.vue?vue&type=style&index=0&id=2ef1c4c5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ef1c4c5",
  null
  
)

export default component.exports